export const getPaymentMethod = (status) => {
  switch (status) {
    case "ONLINE_BANK_CARD":
      return paymentMethods.card_online;
    case "MANUAL":
      return paymentMethods.manual;
    case "MANUAL_BANK_CARD":
      return paymentMethods.card_manual;
    case "CASH":
      return paymentMethods.cash;
    default:
      return paymentMethods.unknown;
  }
};

export const paymentMethods = {
  card_online: {
    label: "CB en ligne",
    code: "ONLINE_BANK_CARD",
    status: "valid",
    style: {
      color: "white",
      border: "none",
      backgroundColor: "#67bc75",
    },
    invertedStyle: {
      color: "#67bc75",
      borderColor: "#67bc75",
    },
  },
  manual: {
    label: "Manuel",
    code: "MANUAL",
    status: "warning",
    style: {
      color: "white",
      border: "none",
      backgroundColor: "#f5bd1f",
    },
    invertedStyle: {
      color: "#f5bd1f",
      borderColor: "#f5bd1f",
    },
  },
  card_manual: {
    label: "CB sur place",
    code: "MANUAL_BANK_CARD",
    status: "warning",
    style: {
      color: "white",
      border: "none",
      backgroundColor: "#f5bd1f",
    },
    invertedStyle: {
      color: "#f5bd1f",
      borderColor: "#f5bd1f",
    },
  },
  cash: {
    label: "Espèce",
    code: "CASH",
    status: "warning",
    style: {
      color: "white",
      border: "none",
      backgroundColor: "#f5bd1f",
    },
    invertedStyle: {
      color: "#f5bd1f",
      borderColor: "#f5bd1f",
    },
  },
  unknown: {
    label: "?",
    state: "passive",
    code: "unknown",
    style: {
      color: "white",
      border: "none",
      backgroundColor: "#bdbdbd",
    },
    invertedStyle: {
      color: "#e3e3e3",
      borderColor: "#e3e3e3",
    },
  },
};
